
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_1euyi_97",
  "root": "awsui_root_p8a6i_1euyi_133",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_1euyi_175",
  "header-refresh": "awsui_header-refresh_p8a6i_1euyi_175",
  "list": "awsui_list_p8a6i_1euyi_184",
  "list-grid-1": "awsui_list-grid-1_p8a6i_1euyi_195",
  "card": "awsui_card_p8a6i_1euyi_97",
  "list-grid-2": "awsui_list-grid-2_p8a6i_1euyi_198",
  "list-grid-3": "awsui_list-grid-3_p8a6i_1euyi_201",
  "list-grid-4": "awsui_list-grid-4_p8a6i_1euyi_204",
  "list-grid-5": "awsui_list-grid-5_p8a6i_1euyi_207",
  "list-grid-6": "awsui_list-grid-6_p8a6i_1euyi_210",
  "list-grid-7": "awsui_list-grid-7_p8a6i_1euyi_213",
  "list-grid-8": "awsui_list-grid-8_p8a6i_1euyi_216",
  "list-grid-9": "awsui_list-grid-9_p8a6i_1euyi_219",
  "list-grid-10": "awsui_list-grid-10_p8a6i_1euyi_222",
  "list-grid-11": "awsui_list-grid-11_p8a6i_1euyi_225",
  "list-grid-12": "awsui_list-grid-12_p8a6i_1euyi_228",
  "list-grid-13": "awsui_list-grid-13_p8a6i_1euyi_231",
  "list-grid-14": "awsui_list-grid-14_p8a6i_1euyi_234",
  "list-grid-15": "awsui_list-grid-15_p8a6i_1euyi_237",
  "list-grid-16": "awsui_list-grid-16_p8a6i_1euyi_240",
  "list-grid-17": "awsui_list-grid-17_p8a6i_1euyi_243",
  "list-grid-18": "awsui_list-grid-18_p8a6i_1euyi_246",
  "list-grid-19": "awsui_list-grid-19_p8a6i_1euyi_249",
  "list-grid-20": "awsui_list-grid-20_p8a6i_1euyi_252",
  "selection-control": "awsui_selection-control_p8a6i_1euyi_256",
  "loading": "awsui_loading_p8a6i_1euyi_266",
  "empty": "awsui_empty_p8a6i_1euyi_267",
  "has-header": "awsui_has-header_p8a6i_1euyi_274",
  "refresh": "awsui_refresh_p8a6i_1euyi_277",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_p8a6i_1euyi_277",
  "card-header": "awsui_card-header_p8a6i_1euyi_348",
  "card-header-inner": "awsui_card-header-inner_p8a6i_1euyi_356",
  "card-selectable": "awsui_card-selectable_p8a6i_1euyi_360",
  "card-selected": "awsui_card-selected_p8a6i_1euyi_363",
  "section": "awsui_section_p8a6i_1euyi_371",
  "section-header": "awsui_section-header_p8a6i_1euyi_379",
  "section-content": "awsui_section-content_p8a6i_1euyi_385",
  "footer-pagination": "awsui_footer-pagination_p8a6i_1euyi_395"
};
  